<script>
import widget from "../../Widget.vue";
import MargettsApi from "../../../modules/margetts-api";
import Modal from "../../Modal.vue";
import {nextTick} from "vue";

export default {
    name: 'Review',
    components: {Modal},
    extends: widget,
    emits: ["eventSubmitApplication", "isLoading"],
    props: ["applicationFormValues"],
    computed: {
        lumpSum() {
            return this.applicationFormValues.lumpSum.lump_sum;
        }
    },

    data() {
        return {
            reviewDetails: {},
            showModal: false,
        }
    },

    beforeMount() {
        this.init();
    },

    methods: {
        async init() {
            this.$emit('isLoading', true);

            let formValues = {application_id: this.applicationFormValues.applicationFormID};
            await MargettsApi.get('investment-application/review', this.createQueryStringFromParameters(formValues, false), response => {
                if (!response || !response.result) {
                    return MargettsApi.throwNoResponseError();
                }

                if (response.result !== 'success') {
                    return this.throwApiError(response.messages);
                }

                this.reviewDetails = {...response.data};
            }).catch(error => {
                MargettsApi.throwError(error);
            });

            this.$emit('isLoading', false);
        },

        previous() {
            this.$emit('eventSubmitApplication', false);
        },

        submit() {
            this.$emit('eventSubmitApplication', true);
        },

        sign() {
            this.showModal = true;
        },

        formatKey(key) {
            return key.replace(/[_-]/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
        },

        numberFormat(value) {
            return Number(value).toLocaleString('en-US');
        }
    }
}
</script>

<template>
    <section class="question" id="page5">
        <h2>Application Details</h2>

        <div>
            <div><span class="label">Type</span> {{ formatKey(applicationFormValues.applicationType) }}</div>
            <div><span class="label">Reference</span>{{ applicationFormValues.applicationFormID }}</div>
        </div>

        <h2>Investors</h2>
        <table>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Date of birth</th>
                    <th>Address</th>
                    <th>Postcode</th>
                    <th>Account Reference</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ reviewDetails?.investors?.name }}</td>
                    <td>{{ reviewDetails?.investors?.date_of_birth }}</td>
                    <td>{{ reviewDetails?.investors?.address }}</td>
                    <td>{{ reviewDetails?.investors?.postcode }}</td>
                    <td>{{ reviewDetails?.investors?.code ?? 'New' }}</td>
                </tr>
            </tbody>

        </table>

        <h2>Investment</h2>
        <div>
            <div class="mb-1-5"><span class="label">Amount</span> £{{ numberFormat(lumpSum) }}</div>
        </div>

        <table class="small-table">
            <thead>
                <tr>
                    <th>Asset</th>
                    <th>Amount</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="asset in reviewDetails.assets">
                    <tr>
                        <td>{{ asset.name }}</td>
                        <td>{{ Number(asset.amount) }}%</td>
                    </tr>
                </template>
            </tbody>
        </table>

        <div class="investment-application-navigation-controls form-group" style="justify-content: flex-end !important;">
            <button class="button button-primary" @click.stop="print">
                <i class="fas fa-print"></i>Print
            </button>
        </div>

        <div class="investment-application-navigation-controls form-group">
            <Modal :show="showModal" @close="showModal = false">
                <div class="sign-modal">
                    <label>Sign Here:</label>
                    <textarea class="form-control" rows="5"></textarea>
                </div>
                <template #footer>
                    <button class="button submit" @click.stop="submit">
                        <span>Submit</span>
                    </button>
                </template>
            </Modal>

            <button class="button-primary button" @click.stop="sign">
                <span>Sign</span>
            </button>

            <button class="button" @click.stop="previous">
                Previous
            </button>
        </div>
    </section>
</template>


<style scoped>
.mb-1-5 {
    margin-bottom: 1.5em !important;
}

.review-row-col-12 > .form-group, .distribution {
    width: fit-content !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    margin: 0.5em !important;
    background-color: #F2F2F2;
    overflow: hidden;
}

.sign-modal {
    display: flex;
    flex-direction: column;
    margin-top: 2em;
    align-items: flex-start;
}


h2 {
    font-weight: 600;
    margin-top: 40px;
}

.label {
    font-weight: bold;
    width: 120px;
    display: inline-block;
}

table {
    border-collapse: collapse;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 40px;
}

table, th, td {
    border: 2px solid #000;
}

th {
    background: #e6e6e6;
    padding: 8px;
    font-weight: bold;
    text-align: left;
}

td {
    padding: 8px;
}

.small-table {
    width: auto;
}

</style>
